export default __webpack_public_path__ + "static/media/contaBasica.4411aeae.png";